import React from 'react';
import './error-boundary.styles.scss';
import milton from './milton-error.png';

/**
 * Catches render-phase errors from anything below it and shows a fallback
 * instead of letting React tear down the whole root (which leaves a blank page).
 *
 * Must be a class component — getDerivedStateFromError / componentDidCatch
 * have no hooks equivalent.
 */
class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      componentStack: null
    };
  }

  // Runs during the render phase: swap state so the next render shows the fallback.
  static getDerivedStateFromError(error) {
    return { 'hasError': true, 'error': error };
  }

  // Runs after the DOM is updated: side effects (logging) belong here.
  componentDidCatch(error, errorInfo) {
    this.setState({ 'componentStack': errorInfo?.componentStack ?? null });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  }

  handleGoHome = () => {
    window.location.href = '/';
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className='error-boundary'>
        <div className='g-card error-boundary-card'>
          <div className='card-title'>Something went wrong</div>
          <div className='g-space-1'></div>
          <div className='error-icon'>
            <img src={milton} alt="Error" />
          </div>
          <div className='g-space-2'></div>
          <div className=''>
            This page hit an unexpected error. Reloading usually fixes it.
            If it keeps happening, send us the details below.
          </div>
          <div className='g-space-1'></div>
          <div className='buttons'>
            <button
              className='g-button primary'
              onClick={this.handleReload}>
              Reload Page
            </button>
            <button
              className='g-button'
              onClick={this.handleGoHome}>
              Go Home
            </button>
          </div>
          <div className='g-space-1'></div>
          <details className='error-details'>
            <summary>Error details</summary>
            <pre>
              {String(this.state.error?.stack ?? this.state.error)}
              {this.state.componentStack}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
